export default "__VITE_ASSET__D1z3uhHu__"